<template>
  <section class="campaign">
    <main class="main animated fadeIn faster" :class="{ 'expand-main': isMenuCollapse }">
      {{ udpdateHeader('admin-system-chat') }}
      <ol class="breadcrumb">
        <li class="breadcrumb-item active">{{ $t('lang.menu.admin_system_chat') }}</li>
      </ol>
      <div class="contenedor animated fadeIn faster">
        <div class="styles-steps pb-4">
          <div class="card shadow-sm">
            <div class="card-body">
              <p class="text-muted small mb-3">
                {{ $t('lang.label.admin_system_chat_help') }}
              </p>

              <div
                ref="thread"
                class="border rounded bg-light p-3 mb-3"
                style="min-height: 280px; max-height: 55vh; overflow-y: auto;"
              >
                <div v-for="(m, idx) in messages" :key="idx" class="mb-3">
                  <div class="font-weight-bold text-primary small" style="white-space: normal;">
                    {{ m.role === 'user' ? $t('lang.label.chat_you') : $t('lang.label.chat_assistant_name') }}
                  </div>
                  <div style="white-space: pre-wrap;">{{ m.content }}</div>

                  <div v-if="m.role === 'assistant' && m.debug" class="mt-2">
                    <button
                      type="button"
                      class="btn btn-sm btn-outline-secondary"
                      @click="toggleDebug(idx)"
                    >
                      {{ $t('lang.label.admin_system_chat_debug_button') }}
                    </button>

                    <div v-if="debugExpanded[idx]" class="mt-2 small border rounded bg-white p-2 text-monospace">
                      <div><strong>{{ $t('lang.label.admin_system_chat_debug_title') }}</strong></div>
                      <div>
                        iterations: {{ m.debug.iterations || 0 }} |
                        tools: {{ (m.debug.tool_calls && m.debug.tool_calls.length) || 0 }}
                      </div>

                      <div v-if="m.debug.tool_calls && m.debug.tool_calls.length" class="mt-1">
                        <div v-for="(tc, tIdx) in m.debug.tool_calls" :key="`${idx}-${tIdx}`">
                          - {{ tc.name }} {{ formatDebugArgs(tc.args) }}
                        </div>
                      </div>
                      <div v-else class="mt-1 text-muted">{{ $t('lang.label.admin_system_chat_no_debug') }}</div>
                    </div>
                  </div>
                </div>

                <div v-if="loading" class="mb-1">
                  <div class="font-weight-bold text-primary small">{{ $t('lang.label.chat_assistant_name') }}</div>
                  <div class="text-muted">{{ $t('lang.label.admin_system_chat_thinking') }}</div>
                </div>
              </div>

              <div v-if="error" class="alert alert-danger small">{{ error }}</div>

              <div class="form-group mb-0">
                <textarea
                  v-model="draft"
                  class="form-control"
                  rows="3"
                  :disabled="loading"
                  :placeholder="$t('lang.label.admin_system_chat_placeholder')"
                  @keydown.enter.exact.prevent="submit"
                />
              </div>

              <div class="text-right mt-2">
                <button type="button" class="btn btn-primary" :disabled="loading || !draft.trim()" @click="submit">
                  {{ loading ? $t('lang.label.admin_system_chat_thinking_button') : $t('lang.button.send') }}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </main>
  </section>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import { adminSystemChatService } from '@/_services/adminSystemChat.service'

export default {
  data() {
    return {
      messages: [],
      draft: '',
      loading: false,
      error: '',
      debugExpanded: {},
    }
  },
  computed: {
    ...mapState({
      isMenuCollapse: (state) => state.sidebar.isNavOpen,
    }),
  },
  created() {
    this.changeHeaderTab({ tab: 'ALL' })
  },
  methods: {
    ...mapActions('header', { changeHeaderTab: 'changeTab' }),
    ...mapActions('headertopbar', {
      setCurrentRoute: 'setRoute',
      setCurrentRouteChild: 'setRouteChild',
    }),
    udpdateHeader(route) {
      this.setCurrentRoute({ page: route })
      this.setCurrentRouteChild({ child: '' })
    },
    toggleDebug(idx) {
      this.$set(this.debugExpanded, idx, !this.debugExpanded[idx])
    },
    formatDebugArgs(args) {
      if (!args || typeof args !== 'object') return ''
      try {
        const txt = JSON.stringify(args)
        return txt.length > 180 ? `${txt.slice(0, 180)}...` : txt
      } catch (e) {
        return ''
      }
    },
    scrollBottom() {
      this.$nextTick(() => {
        const el = this.$refs.thread
        if (el) el.scrollTop = el.scrollHeight
      })
    },
    async submit() {
      const text = this.draft.trim()
      if (!text || this.loading) return
      this.error = ''
      this.messages.push({ role: 'user', content: text })
      this.draft = ''
      this.scrollBottom()

      const history = this.messages.slice(0, -1).map((m) => ({
        role: m.role,
        content: m.content,
      }))

      this.loading = true
      try {
        const res = await adminSystemChatService.sendChat(text, history)
        if (res.answer) {
          this.messages.push({ role: 'assistant', content: res.answer, debug: res.debug || null })
        } else {
          this.messages.push({
            role: 'assistant',
            content: this.$t('lang.label.admin_system_chat_need_specific'),
            debug: res.debug || null,
          })
          this.error = res.error ? (typeof res.error === 'string' ? res.error : JSON.stringify(res.error)) : ''
        }
      } catch (e) {
        this.messages.push({
          role: 'assistant',
          content: this.$t('lang.label.admin_system_chat_need_specific'),
        })
        this.error = (e && e.message) || String(e)
      } finally {
        this.loading = false
        this.scrollBottom()
      }
    },
  },
}
</script>
